import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import { API } from "@/lib/api";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const LABEL = { received: "Received", verifying: "Confirming your identity", in_progress: "Deleting", completed: "Completed", rejected: "Could not be completed (we emailed you why)" };

export default function DeletionStatus() {
  const [params] = useSearchParams();
  const [code, setCode] = useState(params.get("code") || "");
  const [res, setRes] = useState(null);
  const [error, setError] = useState("");
  const look = async (c) => {
    setError(""); setRes(null);
    try { setRes((await axios.get(`${API}/public/data-deletion/${encodeURIComponent(c.trim())}`)).data); }
    catch { setError("No request found with that code."); }
  };
  useEffect(() => { if (params.get("code")) { look(params.get("code")); } }, [params]);
  return (
    <LegalLayout title="Deletion request status" testid="deletion-status-page">
      <form className="flex gap-2" onSubmit={(e) => { e.preventDefault(); look(code); }}>
        <Input placeholder="DEL-XXXXXXXXXX" value={code} onChange={(e) => setCode(e.target.value)} data-testid="status-code-input" />
        <Button type="submit" data-testid="status-check-btn">Check</Button>
      </form>
      {error && <p className="text-sm text-rose-700" data-testid="status-error">{error}</p>}
      {res && (
        <dl className="bg-white border border-slate-200 rounded-2xl p-5 grid grid-cols-[auto,1fr] gap-x-6 gap-y-2 text-sm" data-testid="status-result">
          <dt className="text-slate-500">Code</dt><dd className="font-mono">{res.code}</dd>
          <dt className="text-slate-500">Status</dt><dd className="font-semibold" data-testid="status-value">{LABEL[res.status] || res.status}</dd>
          <dt className="text-slate-500">Request</dt><dd>{res.scope}</dd>
          <dt className="text-slate-500">Submitted</dt><dd>{new Date(res.submitted_at).toLocaleString("en-GB")}</dd>
          {res.completed_at && <><dt className="text-slate-500">Completed</dt><dd>{new Date(res.completed_at).toLocaleString("en-GB")}</dd></>}
        </dl>)}
    </LegalLayout>
  );
}
